import { useNativePlatform } from "@/hooks/useNativePlatform";
import { nativeSheetExpandPreference } from "@/lib/native/nativeSheetExpandPreference";
import { cn } from "@/lib/utils";

/** Shared props for nested native sheets inside flows (post-ad, register, etc.). */
export function nativeNestedSheetDialogProps(
  open: boolean,
  options?: { expandable?: boolean; form?: boolean },
) {
  const { isNative } = useNativePlatform();
  const expandable = options?.expandable === true && isNative;
  const form = options?.form === true && isNative;
  return {
    nested: isNative,
    sheetOpen: open,
    expandable,
    compact: isNative && !expandable,
    className: isNative
      ? cn(
          expandable
            ? "native-nested-expandable-sheet"
            : "native-nested-flow-sheet native-sheet-compact",
          form && "native-sheet-form",
        )
      : undefined,
  } as const;
}

/** Apply persisted expand preference when a nested sheet opens. */
export function shouldOpenNativeSheetExpanded(): boolean {
  return nativeSheetExpandPreference.get();
}
